module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAKElEQVQ4T2NgGBTgPxCRg4eTAQwMq/6ThweNAf9nAv1EBh5OBgxtAAB1bEZi8hkpIAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/AM.png
// module id = 1073
// module chunks = 0